import { type CalendarDate } from './dateutils';
import { MAX_INVALIDATION_ENTITY_IDS } from './invalidationBus';

export const RENT_TIME_ZONE = 'Europe/Brussels';

export const RENT_MATRIX_PAGE_SIZE = MAX_INVALIDATION_ENTITY_IDS;

export const RENT_FORECAST_FISCAL_YEARS = 1;

export const getLatestRentFiscalYear = (at: CalendarDate): number => at.year + RENT_FORECAST_FISCAL_YEARS;
